import React from 'react';
import { Link } from 'react-router-dom';
import 'primeicons/primeicons.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-icons">
        <div className="footer-item">
          <Link to="/">
            <i className="fas fa-home"></i>
            <span className="footer-label">Home</span>
          </Link>
        </div>
        <div className="footer-item">
          <Link to="/agenda">
            <i className="far fa-calendar-alt"></i>
            <span className="footer-label">Agenda</span>
          </Link>
        </div>
        <div className="footer-item">
          <Link to="/discover">
            <i className="pi pi-sparkles"></i>
            <span className="footer-label">Discover</span>
          </Link>
        </div>
        <div className="footer-item">
          <Link to="/whats-hot">
            <i className="fa-solid fa-fire"></i>
            <span className="footer-label">What's Hot</span>
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
